import { HOME_PORTAL_URL } from "../env";

export async function fetchTrialExpirationDate(
  homePortalAppId: string
): Promise<string | null> {
  try {
    const response = await fetch(
      `${HOME_PORTAL_URL}/apps/${homePortalAppId}/trialExpiresAt`
    );

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const json = (await response.json()) as { trialExpiresAt: string };

    return json.trialExpiresAt;
  } catch {
    return null;
  }
}
